import { z } from 'zod';

// RFC 6902 JSON Patch operations
export const PatchOp = z.discriminatedUnion('op', [
  z.object({ op: z.literal('add'), path: z.string(), value: z.unknown() }),
  z.object({ op: z.literal('remove'), path: z.string() }),
  z.object({ op: z.literal('replace'), path: z.string(), value: z.unknown() }),
  z.object({ op: z.literal('move'), from: z.string(), path: z.string() }),
  z.object({ op: z.literal('copy'), from: z.string(), path: z.string() }),
  z.object({ op: z.literal('test'), path: z.string(), value: z.unknown() }),
]);
export type PatchOp = z.infer<typeof PatchOp>;

export const Patch = z.array(PatchOp);
export type Patch = z.infer<typeof Patch>;
